import SVGBase, { type SVGComponentProps } from './SVGBase';

const path = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.02667 4.36008C5.78885 4.37787 5.6085 4.58188 5.62 4.82008L6.07333 13.0601C6.08744 13.2889 6.27738 13.4672 6.50667 13.4667C6.62164 13.4616 6.72982 13.4109 6.80736 13.3258C6.8849 13.2408 6.92543 13.1284 6.92 13.0134L6.48667 4.77341C6.46892 4.5346 6.26601 4.35227 6.02667 4.36008ZM8.32 4.36008C8.08068 4.36008 7.88667 4.55409 7.88667 4.79341V13.0334C7.88667 13.2727 8.08068 13.4667 8.32 13.4667C8.55932 13.4667 8.75333 13.2727 8.75333 13.0334V4.79341C8.75333 4.55409 8.55932 4.36008 8.32 4.36008ZM9.69333 13.0134L10.1467 4.77341H10.1267C10.135 4.6186 10.2253 4.47999 10.3635 4.4098C10.5018 4.33962 10.667 4.34851 10.7969 4.43314C10.9268 4.51776 11.0017 4.66527 10.9933 4.82008L10.54 13.0601C10.5259 13.2889 10.336 13.4672 10.1067 13.4667C9.9917 13.4616 9.88351 13.4109 9.80597 13.3258C9.72843 13.2408 9.68791 13.1284 9.69333 13.0134ZM14.2 2.53341H11.0133V2.00008C11.0133 1.2637 10.4164 0.666748 9.68 0.666748H6.93333C6.19695 0.666748 5.6 1.2637 5.6 2.00008V2.53341H2.43333C2.19401 2.53341 2 2.72742 2 2.96675C2 3.20607 2.19401 3.40008 2.43333 3.40008H3.26L3.92667 13.7534C3.92245 14.602 4.592 15.3011 5.44 15.3334H11.2C12.0383 15.3193 12.7155 14.645 12.7333 13.8067L13.3667 3.40008H14.2C14.4393 3.40008 14.6333 3.20607 14.6333 2.96675C14.6333 2.72742 14.4393 2.53341 14.2 2.53341ZM6.48667 2.00008C6.48489 1.87985 6.53095 1.76383 6.61472 1.67756C6.69849 1.59129 6.8131 1.54184 6.93333 1.54008H9.7C9.82024 1.54184 9.93485 1.59129 10.0186 1.67756C10.1024 1.76383 10.1484 1.87985 10.1467 2.00008V2.53341H6.48667V2.00008ZM11.8667 13.7134C11.8667 14.0816 11.5682 14.3801 11.2 14.3801H5.45333C5.07617 14.3587 4.7825 14.0445 4.78667 13.6667L4.14 3.40008H12.5L11.8667 13.7134Z"
      fill="#EB1400"
    />
  </svg>
);

function TrashCan({ className, title = 'Trash Can' }: SVGComponentProps) {
  return (
    <SVGBase
      className={className}
      labeledBy="trash-can-svg"
      path={path}
      title={title}
      viewBox="0 0 16 16"
    />
  );
}

export default TrashCan;
